<template>
  <div class="home">
    <Header />
    <Gallery />
    <DevGrid />
  </div>
</template>

<script>
  import Header from "./header";
  import Gallery from "./gallery";
  import DevGrid from "./dev-grid.vue";

  export default {
    name: 'Home',
    data() {
      return {};
    },
    components: {
      Header,
      Gallery,
      DevGrid
    },
  }
</script>